import styled, { css } from "styled-components/native";
import { View } from "react-native";
import { space, layout, compose } from "styled-system";
import { Theme } from "../../theming/types";

const styledUtils = compose(space, layout);

export const Container = styled(View)<{ showOnlySelections?: boolean }>`
  overflow: hidden;
  ${styledUtils}
  border-radius: ${({ theme }: { theme: Theme }) => theme.radii.xs};
  ${({
    showOnlySelections,
    theme
  }: {
    showOnlySelections?: boolean;
    theme: Theme;
  }) =>
    !showOnlySelections &&
    css`
      border: 1px solid ${theme.colorTokens.border.default};
    `}
`;
export const Header = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 1px;
  background-color: ${({ theme }: { theme: Theme }) =>
    theme.colorTokens.background.layer};
  border-bottom-color: ${({ theme }: { theme: Theme }) =>
    theme.colors.blue["100"]};
  padding: ${({ theme }: { theme: Theme }) =>
    `${theme.space["space-2"]} ${theme.space["space-4"]}`};
`;

export const ContentActionsWrapper = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const Content = styled(View)<{ hasButtons: boolean }>`
  background-color: ${({ theme }: { theme: Theme }) =>
    theme.colorTokens.background.surface};
  padding: ${({ theme }: { theme: Theme }) => theme.space["space-4"]};
  max-width: ${({ hasButtons }: { hasButtons: boolean }) =>
    hasButtons ? "calc(100% - 72px)" : "100%"};
`;

export const Actions = styled(View)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }: { theme: Theme }) => theme.space["space-3"]};
  margin: ${({ theme }: { theme: Theme }) =>
    `${theme.space["space-2"]} ${theme.space["space-4"]} ${theme.space["space-2"]} 0`};
`;

export const VerticalParagraphLeft = styled(View)`
  text-align: left;
`;

export const VerticalParagraphRight = styled(View)`
  text-align: right;
`;
